// CALL-747: derive the corrected-totals release state shown as an alert below the
// BiddingCalculated filters, for the selected working unit location + month.
// The i18n keys carry a {{month}} placeholder interpolated at render time.

export type CorrectedTotalsReleaseState = {
    severity: 'success' | 'warning' | 'error';
    messageKey: string;
};

/**
 * Maps the presence of released vs. draft corrected totals to an alert state.
 *
 * - released + drafts → success, but distinct copy (released exist, newer drafts still pending)
 * - released only     → success
 * - drafts only       → warning
 * - none              → error
 */
export const deriveCorrectedTotalsReleaseState = (
    hasReleased: boolean,
    hasDrafts: boolean
): CorrectedTotalsReleaseState => {
    if (hasReleased && hasDrafts) {
        return {
            severity: 'success',
            messageKey: 'bidding.correctedTotals.releasedWithNewerDrafts',
        };
    }
    if (hasReleased) {
        return { severity: 'success', messageKey: 'bidding.correctedTotals.released' };
    }
    if (hasDrafts) {
        return { severity: 'warning', messageKey: 'bidding.correctedTotals.draftOnly' };
    }
    return { severity: 'error', messageKey: 'bidding.correctedTotals.none' };
};
